module.exports = __webpack_public_path__ + "static/media/arrowline2.3545cd35.svg";